import React, { useEffect, useState } from "react";
import Permissions from "../../supportFunctions/Permissions";
import { AdminNavItems } from "./MenuOptions";
import { INavItem } from "./MenuOptionsHelpers";
import LinkList from "../../sharedComponents/LinkList";
import { useLocation } from "react-router-dom";
import { useFlags } from "launchdarkly-react-client-sdk";
import UsersService from "@velocity-ehs/user-utils-module";
import { useTranslation } from "react-i18next";
import { sortNavItemArrayByLabel } from "../../supportFunctions/ArrayFunctions";

const AdminSettingsMenu: React.FC = () => {
  const location = useLocation();
  const allFlags = useFlags();
  const { permissions, user } = UsersService;
  const { t } = useTranslation();
  const [adminItems, setAdminItems] = useState<INavItem[]>([]);

  const hasPermissionForNavItem = (
    permission: string[],
    showIfAnyPermission: boolean = false
  ): boolean => {
    return Permissions.IsAllowed(permission, permissions, showIfAnyPermission);
  };

  const getAdminItems = () => {
    let navItems: INavItem[] = [];

    const assignedAdminApplications =
      UsersService.user.assignedAdminApplications;

    AdminNavItems.forEach((item) => {
      if (
        item.flag &&
        (item.invertFeatureFlag
          ? allFlags[item.flag] === true
          : allFlags[item.flag] === false)
      ) {
        return null;
      }

      if (hasPermissionForNavItem(item.permission, item.showIfAnyPermission)) {
        navItems.push(item);
      }
    });

    assignedAdminApplications.forEach((item) => {
      item = {
        label: item.name,
        path: item.redirectUrl,
      };
      navItems.push(item);
    });

    const formattedNavItems = navItems.map((item) => {
      if (item.label === "universal_Configuration") {
        return {
          ...item,
          label: `EHS ${t(item.label)}`,
        };
      } else {
        return item;
      }
    });

    return sortNavItemArrayByLabel(
      formattedNavItems,
      user.preferredLanguage,
      t
    );
  };

  const setActivePath = (pathname: string, items: INavItem[]) => {
    const subPath = getFirstPathSegment(pathname);
    const activeItems = items.map((item) => {
      if (subPath === getFirstPathSegment(item.path)) {
        item.selected = true;
      } else {
        item.selected = false;
      }
      return item;
    });

    return activeItems;
  };

  function getFirstPathSegment(path: string) {
    // Remove any leading or trailing slashes
    const cleanedPath = path.replace(/^(?:\/)|(?:\/)$/g, "");
    // Split by slash and return the first segment
    return cleanedPath.split("/")[0];
  }

  useEffect(() => {
    const currentItems = setActivePath(location.pathname, getAdminItems());
    setAdminItems(currentItems);
    // eslint-disable-next-line
  }, [allFlags, permissions, location]);

  return <LinkList items={adminItems} />;
};

export default AdminSettingsMenu;
